export default [
  'soil',
  'degradation',
  'sentinel',
  'fire',
];
